import React, { Fragment } from 'react'
import { Link } from 'react-router-dom'

import PropTypes from 'prop-types'

import './impressum.css'

const Impressum = (props) => {
  return (
    <div className="impressum-container1">
      <span className="impressum-title">
        {props.impressumTitle ?? (
          <Fragment>
            <span className="impressum-text35">Impressum</span>
          </Fragment>
        )}
      </span>
      <div className="impressum-container2">
        <span className="impressum-name">
          {props.nameTitle ?? (
            <Fragment>
              <span className="impressum-text15">Name:</span>
            </Fragment>
          )}
        </span>
        <span className="impressum-name-text">
          {props.nameText ?? (
            <Fragment>
              <span className="impressum-text28">Stefan Lacher</span>
            </Fragment>
          )}
        </span>
        <span className="impressum-standort">
          {props.standortTitle ?? (
            <Fragment>
              <span className="impressum-text29">
                Standort der Gewerbeberechtigung:
              </span>
            </Fragment>
          )}
        </span>
        <span className="impressum-standort-text">
          {props.standortText ?? (
            <Fragment>
              <span className="impressum-text20">
                <span>Siehdichfürstraße 131</span>
                <br></br>
                <span>2231 Strasshof an der Nordbahn</span>
                <br></br>
                <span>Austria</span>
                <br></br>
              </span>
            </Fragment>
          )}
        </span>
        <span className="impressum-unternehmensgegenstand">
          {props.unternehmensgegenstandTitle ?? (
            <Fragment>
              <span className="impressum-text13">Unternehmensgegenstand:</span>
            </Fragment>
          )}
        </span>
        <span className="impressum-unternehmensgegenstand-text">
          {props.unternehmensgegenstandText ?? (
            <Fragment>
              <span className="impressum-text36">
                Dienstleistungen in der automatischen Datenverarbeitung und
                Informationstechnik
              </span>
            </Fragment>
          )}
        </span>
        <span className="impressum-kontaktdaten">
          {props.kontaktTitle ?? (
            <Fragment>
              <span className="impressum-text32">Kontaktdaten:</span>
            </Fragment>
          )}
        </span>
        <span className="impressum-kontaktdaten-text">
          {props.kontaktText ?? (
            <Fragment>
              <span className="impressum-text16">
                E-Mail: contact@stefanlacher.com
              </span>
            </Fragment>
          )}
        </span>
        <span className="impressum-mitgliedschaft">
          {props.mitgliedTitle ?? (
            <Fragment>
              <span className="impressum-text33">
                Mitgliedschaften bei der Wirtschaftskammerorganisation:
              </span>
            </Fragment>
          )}
        </span>
        <span className="impressum-mitgliedschaft-text">
          {props.mitgliedText ?? (
            <Fragment>
              <span className="impressum-text12">
                Mitglied der Wirtschaftskammer Österreich (WKÖ),
                Wirtschaftskammer Niederösterreich (WKNÖ)
              </span>
            </Fragment>
          )}
        </span>
        <span className="impressum-rechtsvorschriften">
          {props.rechtsvorschriftenTitle ?? (
            <Fragment>
              <span className="impressum-text11">
                Anwendbare Rechtsvorschriften und Zugang dazu:
              </span>
            </Fragment>
          )}
        </span>
        <span className="impressum-rechtsvorschriften-text">
          {props.rechtsvorschriftenText ?? (
            <Fragment>
              <span className="impressum-text17">
                <span>Gewerbeordnung: www.ris.bka.gv.at</span>
                <br></br>
              </span>
            </Fragment>
          )}
        </span>
        <span className="impressum-aufsichtsbehrde">
          {props.aufsichtsbehoerdeTitle ?? (
            <Fragment>
              <span className="impressum-text14">
                Aufsichtsbehörde/Gewerbebehörde:
              </span>
            </Fragment>
          )}
        </span>
        <span className="impressum-aufsichtsbehrde-text">
          {props.aufsichtsbehoerdeText ?? (
            <Fragment>
              <span className="impressum-text38">
                Bezirkshauptmannschaft Gänserndorf
              </span>
            </Fragment>
          )}
        </span>
        <span className="impressum-zweck">
          {props.zweckTitle ?? (
            <Fragment>
              <span className="impressum-text34">Zweck der Webseite:</span>
            </Fragment>
          )}
        </span>
        <span className="impressum-zweck-text">
          {props.zweckText ?? (
            <Fragment>
              <span className="impressum-text27">
                Information über angebotene IT-Dienstleistungen, insbesondere im
                Bereich Softwarelösungen, Entwicklung, Beratung und verwandte
                Tätigkeiten.
              </span>
            </Fragment>
          )}
        </span>
        <span className="impressum-hinweis">
          {props.hinweisTitle ?? (
            <Fragment>
              <span className="impressum-text31">
                Hinweis zur Datenschutzerklärung:
              </span>
            </Fragment>
          )}
        </span>
        <span className="impressum-hinweis-text">
          {props.hinweisText ?? (
            <Fragment>
              <span className="impressum-text39">
                Informationen zum Datenschutz finden Sie in der
                Datenschutzerklärung.
              </span>
            </Fragment>
          )}
        </span>
      </div>
      <div className="impressum-container3">
        <span className="impressum-text10">
          {props.zurDatenschutzerklaerung ?? (
            <Fragment>
              <span className="impressum-text37">
                Zur Datenschutzerklärung: 
              </span>
            </Fragment>
          )}
        </span>
        <Link to="/privacy-policy" className="impressum-navlink">
          {props.linkPrivacyPolicy ?? (
            <Fragment>
              <span className="impressum-text30">Privacy Policy</span>
            </Fragment>
          )}
        </Link>
      </div>
    </div>
  )
}

Impressum.defaultProps = {
  rechtsvorschriftenTitle: undefined,
  mitgliedText: undefined,
  unternehmensgegenstandTitle: undefined,
  aufsichtsbehoerdeTitle: undefined,
  nameTitle: undefined,
  kontaktText: undefined,
  rechtsvorschriftenText: undefined,
  standortText: undefined,
  zweckText: undefined,
  nameText: undefined,
  standortTitle: undefined,
  linkPrivacyPolicy: undefined,
  hinweisTitle: undefined,
  kontaktTitle: undefined,
  mitgliedTitle: undefined,
  zweckTitle: undefined,
  impressumTitle: undefined,
  unternehmensgegenstandText: undefined,
  zurDatenschutzerklaerung: undefined,
  aufsichtsbehoerdeText: undefined,
  hinweisText: undefined,
}

Impressum.propTypes = {
  rechtsvorschriftenTitle: PropTypes.element,
  mitgliedText: PropTypes.element,
  unternehmensgegenstandTitle: PropTypes.element,
  aufsichtsbehoerdeTitle: PropTypes.element,
  nameTitle: PropTypes.element,
  kontaktText: PropTypes.element,
  rechtsvorschriftenText: PropTypes.element,
  standortText: PropTypes.element,
  zweckText: PropTypes.element,
  nameText: PropTypes.element,
  standortTitle: PropTypes.element,
  linkPrivacyPolicy: PropTypes.element,
  hinweisTitle: PropTypes.element,
  kontaktTitle: PropTypes.element,
  mitgliedTitle: PropTypes.element,
  zweckTitle: PropTypes.element,
  impressumTitle: PropTypes.element,
  unternehmensgegenstandText: PropTypes.element,
  zurDatenschutzerklaerung: PropTypes.element,
  aufsichtsbehoerdeText: PropTypes.element,
  hinweisText: PropTypes.element,
}

export default Impressum
